import React from "react"
import bubbleSection1 from "../../assets/images/section1_bubble.svg"
import bubbleSection2 from "../../assets/images/bubble_art.svg"
import bubbleSection3 from "../../assets/images/section3_bubble.svg"
import {
  HOW_IT_WORKS,
  INFO_SECTION1_HEADING,
  INFO_SECTION1,
  INFO_SECTION2_HEADING,
  INFO_SECTION2,
  INFO_SECTION3_HEADING,
  INFO_SECTION3,
  INFO_SECTION4_HEADING,
  INFO_SECTION4,
} from "../../constants/messages"
import { TextTag as Text } from "../../atoms"
import "./HomePageInfo.scss"

const HomePageInfo = (props) => {
  const { text, icon, onClickIcon, ...rest } = props
  return (
    <div className="home-work-section">
      <div className="sub-head-section">
        <div className="dummy-head-title"></div>
        <div className="ques-box">
          <div className="section-title">
            <Text textType="spaceName">{INFO_SECTION4_HEADING}</Text>
          </div>
          <div>
            <Text className="section-body" textType="bodyHeading">
              {INFO_SECTION4}
            </Text>
          </div>
        </div>
        <div className="dummy-head-title-2"></div>
      </div>
      <div className="head-tag">
        <Text textType="taglineBold" className="colored-text">
          {HOW_IT_WORKS}
        </Text>
      </div>
      <div className="section1">
        <div className="info-box-dummy"></div>
        <div className="info-box">
          <img src={bubbleSection1} alt="invite partner" />
          <div className="section-heading">
            <Text textType="spaceName">{INFO_SECTION1_HEADING}</Text>
          </div>
          <div>
            <Text className="section-body" textType="bodyHeading">
              {INFO_SECTION1}
            </Text>
          </div>
        </div>
      </div>
      <div className="section2">
        <div className="info-box">
          <img src={bubbleSection2} alt="invite partner" />
          <div className="section-heading">
            <Text textType="spaceName">{INFO_SECTION2_HEADING}</Text>
          </div>
          <div>
            <Text className="section-body" textType="bodyHeading">
              {INFO_SECTION2}
            </Text>
          </div>
        </div>
        <div className="info-box-dummy"></div>
      </div>

      <div className="section3">
        <div className="info-box-dummy"></div>
        <div className="info-box">
          <img src={bubbleSection3} alt="invite partner" />
          <div className="section-heading">
            <Text textType="spaceName">{INFO_SECTION3_HEADING}</Text>
          </div>
          <div>
            <Text className="section-body" textType="bodyHeading">
              {INFO_SECTION3}
            </Text>
          </div>
        </div>
      </div>
    </div>
  )
}

export default HomePageInfo
